import React from 'react';
import { Link } from 'react-router-dom';
import './Public.css';
import logo from './logo.png';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="pub-footer" id="contact">
      <div className="pub-container">
        <div className="pub-footer-grid">
          <div className="pub-footer-brand">
            <div className="pub-logo">
              <img src={logo} alt="AI World Community Logo" className="pub-logo-mark" />
              <span className="pub-logo-text" style={{ color: '#fff' }}>AI World<span style={{ color: '#8AB8FF' }}> Community</span></span>
            </div>
            <p>Empowering people, accelerating skills, and building the AI future together — through courses, community, and real-world events.</p>
          </div>
          <div className="pub-footer-col">
            <h4>Explore</h4>
            <Link to="/">Home</Link>
            <a href="/#courses">Courses</a>
            <a href="/#community">Community</a>
            <a href="/#events">Events</a>
          </div>
          <div className="pub-footer-col">
            <h4>Support</h4>
            <a href="/#">Help Center</a>
            <a href="/#">FAQ</a>
            <a href="/#">Privacy</a>
          </div>
          <div className="pub-footer-col">
            <h4>Organisations</h4>
            <Link to="/admin/login">Admin Login</Link>
            <a href="/#">Partner With Us</a>
          </div>
        </div>
        <div className="pub-footer-bottom">
          <p>© {year} AI World Community. All rights reserved.</p>
          <div className="pub-footer-social">
            <a href="/#" aria-label="LinkedIn">in</a>
            <a href="/#" aria-label="YouTube">▶</a>
            <a href="/#" aria-label="Facebook">f</a>
            <a href="/#" aria-label="X">𝕏</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
